// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateRangePicker_picker__yXthW {
  position: absolute;
  background-color: white;
  padding: 1rem;
  box-shadow: 0px 0px 5px gray;
  top: 0px;
  transform: translate(-100%, 0px);
}

.DateRangePicker_component__CvgYy {
  display: flex;
  gap: 0.5rem;
}

.DateRangePicker_date-range-block__yuYvC {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  margin-bottom: 0px;
}
.DateRangePicker_date-range-block__yuYvC > :last-child {
  padding: 8px;
  color: black;
  background-color: #f1f1f1;
  border-radius: 4px;
  height: 36px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.DateRangePicker_date-range-block__yuYvC > :last-child:hover {
  outline: 1px solid #454545;
}
.DateRangePicker_date-range-block__yuYvC > :last-child:last-child {
  margin-bottom: 0px;
}
.DateRangePicker_date-range-block__yuYvC span {
  flex: 1 1;
}
.DateRangePicker_date-range-block__yuYvC i {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DateRangePicker_date-range-block__yuYvC:has(i:last-child:hover) i:last-child {
  border: 1px solid red;
  color: red;
}

.DateRangePicker_range-picker__Z4kIj {
  padding: 1rem;
  display: flex;
  gap: 2rem;
}

.DateRangePicker_bubble__HMrtJ {
  height: 23.3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/DateRangePicker.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,aAAA;EAEA,4BAAA;EAEA,QAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AADF;AAGE;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EACE,0BAAA;AADN;AAGI;EACE,kBAAA;AADN;AAIE;EACE,SAAA;AAFJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAIE;EACE,qBAAA;EACA,UAAA;AAFJ;;AAMA;EACE,aAAA;EACA,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,eAAA;AAHF","sourcesContent":[".picker {\n  position: absolute;\n  background-color: white;\n  padding: 1rem;\n  box-shadow: 0px 0px 5px gray;\n  top: 0px;\n  transform: translate(-100%, 0px);\n}\n\n.component {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.date-range-block {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-bottom: 0px;\n}\n.date-range-block > :last-child {\n  padding: 8px;\n  color: black;\n  background-color: #f1f1f1;\n  border-radius: 4px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.date-range-block > :last-child:hover {\n  outline: 1px solid #454545;\n}\n.date-range-block > :last-child:last-child {\n  margin-bottom: 0px;\n}\n.date-range-block span {\n  flex: 1;\n}\n.date-range-block i {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.date-range-block:has(i:last-child:hover) i:last-child {\n  border: 1px solid red;\n  color: red;\n}\n\n.range-picker {\n  padding: 1rem;\n  display: flex;\n  gap: 2rem;\n}\n\n.bubble {\n  height: 23.3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"picker": `DateRangePicker_picker__yXthW`,
	"component": `DateRangePicker_component__CvgYy`,
	"date-range-block": `DateRangePicker_date-range-block__yuYvC`,
	"range-picker": `DateRangePicker_range-picker__Z4kIj`,
	"bubble": `DateRangePicker_bubble__HMrtJ`
};
export default ___CSS_LOADER_EXPORT___;
